import React from 'react';
import { NavLink, Link } from 'react-router-dom';
import arrow from '../../image/Vector.png';
import video from '../../video/video 1.mp4';
// import '../../index';

const Content = () => (
  <div>
  <div className="content">
       <div
  id="carousel-example-2"
  class="carousel slide carousel-fade"
  data-ride="carousel"
  data-interval="false"
>

  <div className="carousel-inner" role="listbox">
    <div className="carousel-item active">
      <div className="view">
        <video muted autoPlay loop playsinline>
          <source src={video} type="video/mp4" />
        </video>
        <div>
          <ul className='full-bg-img flex-center mask rgba-indigo-light white-text'>
                  <div className="content_body">
                       <span style={{
                color: 'white',
                fontSize:' 1.5rem',
                textShadow: '2px 2px 4px #000000',
                borderRadius: '25px',
                fontStyle: 'italic' }}>
                <ul>
                  <li>LEARN.BUILD.DESIGN</li>
                  <li>Corporate.Blogs.Vblogs</li>
                  <li>e-Commerce.websites.etc</li>
                </ul>
      </span>
      <p className="p-text" style={{color: 'black'}}>
        Integrating information technology to business enterprise
      </p>
      <div className="getstarted">
        <NavLink className="navLink" to="/signup">
          Get Started
          <img className="bodyimg" src={arrow} alt="sign up logo" />
          With Our Awesome Packages
        </NavLink>
      </div>
    </div>
            <button
              type="button"
              className="btn btn-lg mt-5"
              style={{ backgroundColor: 'purple',
                color: 'white',
                width: '250px !important',
                fontSize:' 1.8rem' }}
            >
              <NavLink to='/signup'>REGISTER</NavLink>
            </button>

          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
  </div>

    <div>
   
    </div>

  </div>
);

export default Content;
